<!-- aria-live="polite" only: an empty result is information, not an
     interruption. No role="status" heading noise, no focus stealing. -->
<div class="rak-empty-state" aria-live="polite">
  <p class="rak-empty-state__text">{{ text }}</p>
</div>
